"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var dom_1 = require("../../helpers/dom");
var Icon_1 = __importDefault(require("../Icon"));
var LanguageItem_1 = __importDefault(require("./LanguageItem"));
var MenuItem_1 = __importDefault(require("./MenuItem"));
var styles_1 = __importDefault(require("./styles"));
// tslint:disable max-line-length
var Menu = function (_a) {
    var children = _a.children, isHidden = _a.isHidden, className = _a.className, style = _a.style, languageLabel = _a.languageLabel, languages = _a.languages, username = _a.username, onLanguageClick = _a.onLanguageClick, onSignOut = _a.onSignOut, logoSrc = _a.logoSrc, isForced = _a.isExpanded;
    if (isHidden)
        return null;
    var _b = react_1.useState(false), isExpanded = _b[0], setIsExpanded = _b[1];
    var isExpandedComputed = isForced !== null && isForced !== void 0 ? isForced : isExpanded;
    var classNames = "wrapper " + (isExpandedComputed ? 'expanded' : '');
    var menuRef = react_1.useRef();
    var items = react_1.Children
        .map(children, function (x) { return react_1.isValidElement(x) && react_1.cloneElement(x, { className: 'item', isExpanded: isExpandedComputed }); });
    var logo = isExpandedComputed
        ? react_1.default.createElement("img", { src: logoSrc, className: "logo", onClick: setIsExpanded.bind(undefined, false) })
        : react_1.default.createElement(Icon_1.default, { icon: "menu", className: "logo", onClick: setIsExpanded.bind(undefined, true) });
    var handleClickOutside = function (event) {
        if (isExpanded &&
            !dom_1.isChildNode(menuRef.current, event.target) &&
            menuRef.current !== event.target)
            setIsExpanded(false);
    };
    var handleDropDownClick = function () {
        if (!isExpanded)
            setIsExpanded(true);
    };
    react_1.useEffect(function () {
        var dropDownButtons = document.getElementsByClassName('dropdown');
        document.addEventListener('click', handleClickOutside);
        if (dropDownButtons && dropDownButtons.length) {
            Array.from(dropDownButtons).map(function (dropdown) { return dropdown.addEventListener('click', handleDropDownClick); });
        }
        return function () {
            document.removeEventListener('click', handleClickOutside);
            if (dropDownButtons && dropDownButtons.length) {
                Array.from(dropDownButtons).map(function (dropdown) { return dropdown.removeEventListener('click', handleDropDownClick); });
            }
        };
    });
    return (react_1.default.createElement(styles_1.default, { className: className || '', style: style },
        react_1.default.createElement("div", { className: classNames, ref: menuRef },
            react_1.default.createElement("section", { className: "header" }, logo),
            react_1.default.createElement("section", { className: "items" }, items),
            react_1.default.createElement(LanguageItem_1.default, { isHidden: !languages || !languages.length, isExpanded: isExpandedComputed, languageLabel: languageLabel, languages: languages || [], onLanguageClick: onLanguageClick }),
            react_1.default.createElement(MenuItem_1.default, { isExpanded: isExpandedComputed, isHidden: !username, label: username || '', className: "username " + (!!onSignOut ? 'sign-out' : ''), icon: !!onSignOut ? 'sign-out' : '', onClick: onSignOut }))));
};
exports.default = Menu;
//# sourceMappingURL=index.js.map